export const navLinks = [
  { label: '首页', href: '/' },
  { label: '赛事分类', href: '/category/football' },
  { label: '热门资讯', href: '/category/football?tab=articles' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  platforms: [
    { label: '开云体育平台官网', href: '/' },
    { label: '开云体育平台注册', href: '/about' },
    { label: '开云体育平台登录', href: '/about' },
    { label: '开云体育平台APP下载', href: '/about' },
  ],
  services: [
    { label: '足球赛事', href: '/category/football' },
    { label: '篮球赛事', href: '/category/basketball' },
    { label: '网球赛事', href: '/category/tennis' },
    { label: '电子竞技', href: '/category/esports' },
    { label: '综合赛事', href: '/category/others' },
  ],
  support: [
    { label: '新手攻略', href: '/article/newbie-guide' },
    { label: '常见问题', href: '/about' },
    { label: '优惠活动', href: '/about' },
    { label: '联系我们', href: '/about' },
  ],
};

export const footerContact = {
  serviceHotline: '400-888-9999',
  email: 'service@kaiyunsports.com',
  workHours: '7×24小时全天候服务',
  address: '菲律宾马尼拉博彩监管区',
};